import WatchlistAddRemoveCompanyToggle from './WatchlistAddRemoveCompanyToggle';

export { WatchlistGuestRegistration } from './WatchlistGuestRegistration';

export default WatchlistAddRemoveCompanyToggle;
